import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { AnimatePresence, motion } from 'framer-motion';
interface AccordionProps {
  emoji: string;
  title: string;
  children: React.ReactNode;
  defaultOpen?: boolean;
}
export function Accordion({
  emoji,
  title,
  children,
  defaultOpen = false
}: AccordionProps) {
  const [open, setOpen] = useState(defaultOpen);
  return <div className="overflow-hidden rounded-2xl border border-white/10 bg-hockey-card" data-id="element-20" data-mp="2n3fs6myolpms">
      <button type="button" onClick={() => setOpen(v => !v)} aria-expanded={open} className="flex w-full items-center gap-3 px-4 py-4 text-left" data-id="element-21" data-mp="2i54icc8dzf4k">
        <span className="text-2xl" aria-hidden="true" data-id="element-22" data-mp="2s325sxif97w4">
          {emoji}
        </span>
        <span className="flex-1 text-[15px] font-bold leading-snug text-white" data-id="element-23" data-mp="2s17jpfvez9qg">{title}</span>
        <ChevronDownIcon className={`h-5 w-5 shrink-0 text-hockey-pink transition-transform duration-300 ${open ? 'rotate-180' : ''}`} data-id="element-24" data-mp="11sp5y6xfu85o" />
      </button>
      <AnimatePresence initial={false} data-id="element-25" data-mp="3g5x262g26z0s">
        {open && <motion.div key="content" initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.28,
        ease: 'easeInOut'
      }} className="overflow-hidden" data-id="element-26" data-mp="3l48gapddzvot">
            <div className="border-t border-white/10 px-4 py-4" data-id="element-27" data-mp="3lxa1m46z9g0">{children}</div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}